// Local type definitions for formly configuration
interface TypeOption {
  name: string;
  component: any;
}

interface WrapperOption {
  name: string;
  component: any;
}
import { TimeRegistrationWrapper } from '../../../features/admin/modules/modules-entity/templates/details/formly-wrappers/time-registration.wrapper';
import { EnrollmentWrapper } from '../../../features/admin/modules/modules-entity/templates/details/formly-wrappers/enrollment.wrapper';
import { addonsExtension } from './extensions/unit-labels.extension';
import { clearButtonExtension } from './extensions/clear-button.extension';
import { maxLengthCounterExtension } from './extensions/max-length-counter.extension';
import { lockedFieldExtension } from './extensions/locked-field.extension';
import { readonlyExtension } from './extensions/readonly.extension';
import { ReadonlyWrapper } from './readonly/readonly.wrapper';
import { hoverTooltipExtension } from './extensions/hover-tooltip.extension';
import { autocompleteExtension } from './extensions/autocomplete.extension';
import { dataCyExtensionConfig } from './extensions/data-cy.extension';
import { asyncValidationExtensionConfig } from './extensions/async-validation.extension';
import { FormlyWrapperAddons } from '../../../features/admin/modules/modules-entity/templates/details/formly-wrappers/unit-labels';
import { FormlyWrapperClearButton } from '../../../features/admin/modules/modules-entity/templates/details/formly-wrappers/clear-button.wrapper';
import { INPUT_OPTIONS, FormlyCustomInputSettings } from './field-config';

import { FormlyMatColorPickerInputComponent } from './colorpicker.component';
import { FormlyTitleComponent } from './title.component';
import { FormlyRepeatAccordionTypeComponent } from './repeat-accordion.component';
import { FormlyRepeatNumberTypeComponent } from './repeat-number.component';
import { FormlyRepeatTypeComponent } from './repeat.component';
import { FormlyFieldTabs } from './tabs.component';
import { FormlyFieldUploadComponent } from './upload.component';
import { FormlyFieldDateTime } from './datetime.component';
import { FormlyPasswordType } from './password.component';
import { FormlyFieldSegmentButtons } from './segment-buttons.component';
import { FormlyEditorType } from './editor.component';
import { FormlyTimeType } from './time.component';
import { FormlyEmailType } from './email.component';
import { FormlyEmailTagsComponent } from './email-tags.component';
import { FormlyFieldAutocomplete } from './autocomplete.component';
import { FormlyFieldDynamicModuleAutocomplete } from './dynamic-module-autocomplete.component';
import { FormlyRepeatReorderTypeComponent } from './repeat-reorder.component';
import { FormlyDividerComponent } from './divider.component';
import { FormlyFieldIconPickerComponent } from './icon-picker.component';
import { FormlyFieldAddress } from './address.component';
import { FormlyFieldDateOffsetComponent } from './date-offset.component';
import { FormlyFieldPages } from './pages.component';
import { FormlyFieldGroup } from './group.component';
import { FormlyAccordionComponent } from './accordion.component';
import { FormlyFieldName } from './name.component';
import { FormlyFieldAvailability } from './availability.component';
import { FormlyFieldDateHoursCalculator } from './date-hours-calculator.component';
import { CustomMulticheckboxTypeComponent } from './multi-checkbox.component';
import { FormlyLinkedItemsComponent } from './linked-items.component';
import { FormlyLinkageItemsComponent } from './linkage-items.component';
import { FormlyLinkageTagsComponent } from './linkage-tags.component';
import { FormlyLinkageSelectComponent } from './linkage-select.component';
import { FormlyFieldDateComponent } from './date.component';
import { FormlyFieldWeekTime } from './week-time.component';
import { FormlyMatTagsInputComponent } from './tags.component';
import { FormlyFieldGeolocationComponent } from './geolocation.component';
import { FormlyFieldCron } from './cron.component';
import { CustomToggleComponent } from './toggle.component';
import { CustomSelectComponent } from './select.component';
import { CustomRadioButtonsComponent } from './radio.component';
import { CustomCheckboxComponent } from './checkbox.component';
import { FormlyFieldDateRangeComponent } from './date-range.component';
import { FormlyRequiredItemsComponent } from './required-items.component';
import { FormlyFieldReadonlyField } from './readonly-field.component';
import { FormlyFieldReadonlyObject } from './readonly-object.component';
import { FormlyFieldReadonlyEntry } from './readonly-entry.component';
import { FormlyReadonlyOnboardingComponent } from './readonly-onboarding.component';
import { FormlyRouteTypeComponent } from './route.component';
import { FormlyRoutePointComponent } from './route-point.component';
import { FormlyFieldWeekDaysHoursNumber } from './week-days-hours-number.component';
import { FormlyFieldWeekDaysHoursTime } from './week-days-hours-time.component';
import { FormlyFieldDateWeekComponent } from './date-weekpicker.component';
import { FormlyFieldDateRangeWeekComponent } from './date-range-week.component';
import { FormlyLabelComponent } from './label.component';
import { UserRolesCheckboxComponent } from './userroles.component';
import { FormlyFormBuilderComponent } from './form-builder.component';
import { FormlyTextComponent } from './text.component';
import { FormlyWizardComponent } from './wizard.component';
import { FormlyFieldMediaPickerComponent } from './media-picker.component';
import { FormlyFormBuilderToGeneratedFormComponent } from './form-builder-to-generated-form.component';
import { FormlyFieldCurrencyComponent } from './currency.component';
import { FormlyFieldCustomNumberComponent } from './number.component';
import { FormlyFieldYearComponent } from './year.component';
import { FormlyFieldMonthComponent } from './month.component';
import { FormlyIbanBicComponent } from './iban-bic.component';
import { FormlyRDWType } from './rdw.component';
import { FormlyKvkType } from './kvk.component';
import { FormlyAutomaticChecksComponent } from './automatic-checks.component';
import { FormlyBsnType } from './bsn.component';
import { FormlyFuseAlertComponent } from './alert.component';
import { SecureInputComponent } from './secure-input.component';
import { FormlyInlineEntriesComponent } from './inline-entries.component';
import { SelectLinkedEntriesComponent } from './select-linked-entries.component';
import { FormlyFieldRatingComponent } from './rating.component';
import { FormlyFieldUploadDocumentComponent } from './upload-document.component';
import { FormlyFieldDownloadDocumentComponent } from './download-document.component';
import { FormlyFieldSigningUploadComponent } from './signing-upload.component';
import { FormlyFieldSigningSignComponent } from './signing-sign.component';
import { FormlyRequiredDocumentsChecklistComponent } from './required-documents-checklist.component';
import { InterfaceActionButtonFormlyComponent } from './interface-action-button/interface-action-button.component';
import { FormlyModuleSelectComponent } from './module-select.component';
import { FormlySliderComponent } from './slider.component';
import { FormlyLinkedValueComponent } from './linked-value.component';
import { FormlyTemplateMergeInputComponent } from './template-merge-input.component';
import { FormlyOnboardingPrefillMappingComponent } from './onboarding-prefill-mapping.component';
import { RoleBasedRightsComponent } from './role-based-rights.component';
import { OverviewTabComponent } from './readonly/overview-tab.component';
import { OVERVIEW_FIELD_TYPE } from './readonly/overview.types';
import { WRAPPER_OPTIONS } from './wrapper-config';
import { HoverTooltipWrapper } from './hover-tooltip.wrapper';
import { FormlyWrapperMaxLengthCounter } from './max-length-counter.wrapper';

// Component mapping object (component need to be added later because of circular dependency issues)
const COMPONENT_MAP: { [key: string]: any } = {
  'custom-select': CustomSelectComponent,
  'custom-currency': FormlyFieldCurrencyComponent,
  'custom-multicheckbox': CustomMulticheckboxTypeComponent,
  'custom-number': FormlyFieldCustomNumberComponent,
  'custom-radio': CustomRadioButtonsComponent,
  'custom-simple-multicheckbox': CustomCheckboxComponent,
  'custom-toggle': CustomToggleComponent,
  'custom-userroles-multicheckbox': UserRolesCheckboxComponent,
  'download-document': FormlyFieldDownloadDocumentComponent,
  'dynamic-module-autocomplete': FormlyFieldDynamicModuleAutocomplete,
  'form-builder': FormlyFormBuilderComponent,
  'form-builder-generated-form': FormlyFormBuilderToGeneratedFormComponent,
  'fuse-alert': FormlyFuseAlertComponent,
  'iban-bic': FormlyIbanBicComponent,
  'inline-entries': FormlyInlineEntriesComponent,
  'interface-action-button': InterfaceActionButtonFormlyComponent,
  'linkage-items': FormlyLinkageItemsComponent,
  'linkage-select': FormlyLinkageSelectComponent,
  'linkage-tags': FormlyLinkageTagsComponent,
  'linked-items': FormlyLinkedItemsComponent,
  'media-picker': FormlyFieldMediaPickerComponent,
  'module-select': FormlyModuleSelectComponent,
  'readonly-input': FormlyFieldReadonlyField,
  'required-documents-checklist': FormlyRequiredDocumentsChecklistComponent,
  'required-items': FormlyRequiredItemsComponent,
  'route-point': FormlyRoutePointComponent,
  'secure-input': SecureInputComponent,
  'segment-buttons': FormlyFieldSegmentButtons,
  'select-linked-entry': SelectLinkedEntriesComponent,
  'signing-sign': FormlyFieldSigningSignComponent,
  'signing-upload': FormlyFieldSigningUploadComponent,
  'upload-document-entry': FormlyFieldUploadDocumentComponent,
  'week-day-hours-number': FormlyFieldWeekDaysHoursNumber,
  'week-day-hours-time': FormlyFieldWeekDaysHoursTime,
  accordion: FormlyAccordionComponent,
  address: FormlyFieldAddress,
  autocomplete: FormlyFieldAutocomplete,
  availability: FormlyFieldAvailability,
  bsn: FormlyBsnType,
  colorpicker: FormlyMatColorPickerInputComponent,
  cron: FormlyFieldCron,
  date_hours_calculator: FormlyFieldDateHoursCalculator,
  date_offset: FormlyFieldDateOffsetComponent,
  date_range: FormlyFieldDateRangeComponent,
  datepicker_custom: FormlyFieldDateComponent,
  datetime: FormlyFieldDateTime,
  divider: FormlyDividerComponent,
  editor: FormlyEditorType,
  email: FormlyEmailType,
  'email-tags': FormlyEmailTagsComponent,
  geolocation: FormlyFieldGeolocationComponent,
  group: FormlyFieldGroup,
  iconpicker: FormlyFieldIconPickerComponent,
  kvk: FormlyKvkType,
  'automatic-checks': FormlyAutomaticChecksComponent,
  label: FormlyLabelComponent,
  name: FormlyFieldName,
  pages: FormlyFieldPages,
  password: FormlyPasswordType,
  rating: FormlyFieldRatingComponent,
  rdw: FormlyRDWType,
  readonly_entry: FormlyFieldReadonlyEntry,
  readonly_object: FormlyFieldReadonlyObject,
  readonly_onboarding: FormlyReadonlyOnboardingComponent,
  repeat: FormlyRepeatTypeComponent,
  repeat_accordion: FormlyRepeatAccordionTypeComponent,
  repeat_number: FormlyRepeatNumberTypeComponent,
  repeat_reorder: FormlyRepeatReorderTypeComponent,
  route: FormlyRouteTypeComponent,
  slider: FormlySliderComponent,
  tabs: FormlyFieldTabs,
  tags: FormlyMatTagsInputComponent,
  text: FormlyTextComponent,
  time: FormlyTimeType,
  title: FormlyTitleComponent,
  upload: FormlyFieldUploadComponent,
  week: FormlyFieldDateRangeWeekComponent,
  week_time: FormlyFieldWeekTime,
  weekpicker: FormlyFieldDateWeekComponent,
  wizard: FormlyWizardComponent,
  year: FormlyFieldYearComponent,
  month: FormlyFieldMonthComponent,
  'linked-value': FormlyLinkedValueComponent,
  'template-merge-input': FormlyTemplateMergeInputComponent,
};

// Update INPUT_OPTIONS with components
const INPUT_OPTIONS_WITH_COMPONENTS: FormlyCustomInputSettings[] = INPUT_OPTIONS.map(option => ({
  ...option,
  component: COMPONENT_MAP[option.value] || null,
}));

// Internal field types that are NOT exposed in the form-builder type picker (INPUT_OPTIONS),
// but still need to be registered with Formly so they can be used internally by the form-builder UI itself.
const INTERNAL_INPUTS: TypeOption[] = [
  { name: 'template-merge-input', component: FormlyTemplateMergeInputComponent },
  { name: 'role-based-rights', component: RoleBasedRightsComponent },
  // Configured on the onboarding-forms entry, not through the form-builder type picker: it maps the
  // entry root onto the steps of the form being designed, which only makes sense there.
  { name: 'onboarding-prefill-mapping', component: FormlyOnboardingPrefillMappingComponent },
  // Read view's optional Overzicht tab (#21239, task 21250). Internal on purpose: DetailsService
  // synthesises this node, an admin never picks it as a field type.
  { name: OVERVIEW_FIELD_TYPE, component: OverviewTabComponent },
];

export const CUSTOM_INPUTS: TypeOption[] = [
  ...INPUT_OPTIONS_WITH_COMPONENTS.filter(input => input.custom && input.component).map(input => ({
    name: input.value,
    component: input.component,
  })),
  ...INTERNAL_INPUTS,
];

// Wrapper component mapping (separated to prevent circular dependencies)
const WRAPPER_COMPONENT_MAP: { [key: string]: any } = {
  'time-registration-week': TimeRegistrationWrapper,
  enrollment: EnrollmentWrapper,
  addons: FormlyWrapperAddons,
  clear: FormlyWrapperClearButton,
};

// Update WRAPPER_OPTIONS with components
const WRAPPER_OPTIONS_WITH_COMPONENTS = WRAPPER_OPTIONS.map(option => ({
  ...option,
  component: WRAPPER_COMPONENT_MAP[option.value] || null,
}));

export const CUSTOM_WRAPPERS: WrapperOption[] = [
  // Outermost wrapper of a read-mode field: it replaces the type component with a label/value
  // row, so it must sit outside every wrapper that decorates an input. This array is only a
  // name -> component REGISTRY, not the nesting order — the outermost position is set by
  // readonlyExtension (extensions/readonly.extension.ts), which prepends 'readonly' to
  // field.wrappers per field.
  { name: 'readonly', component: ReadonlyWrapper },
  { name: 'hover-tooltip', component: HoverTooltipWrapper },
  { name: 'max-length-counter', component: FormlyWrapperMaxLengthCounter },
  ...WRAPPER_OPTIONS_WITH_COMPONENTS.filter(input => input.custom !== null).map(input => {
    return { name: input.value, component: input.component };
  }),
];

export const CUSTOM_EXTENSIONS = [
  { name: 'hover-tooltip', extension: { prePopulate: hoverTooltipExtension } },
  { name: 'locked-field', extension: { prePopulate: lockedFieldExtension } },
  // Must run after 'hover-tooltip': that extension REPLACES the whole wrappers array
  // (hover-tooltip.extension.ts:27-34), so a 'readonly' prepended before it is dropped again.
  { name: 'readonly', extension: { prePopulate: readonlyExtension } },
  // Bug #21298: password managers/browser autofill need an `autocomplete` attribute on
  // name/contact-shaped inputs — none of them had one before.
  { name: 'autocomplete', extension: { prePopulate: autocompleteExtension } },
  { name: 'addons', extension: { onPopulate: addonsExtension } },
  // Must run after 'addons': addon fields compose the shared clear component
  // in their suffix, while the clear wrapper owns all other generic suffixes.
  { name: 'clear', extension: { onPopulate: clearButtonExtension } },
  // Purely derived from props.maxLength — no admin toggle, so it isn't in
  // WRAPPER_OPTIONS (the form-builder's admin-togglable wrapper picker).
  { name: 'max-length-counter', extension: { onPopulate: maxLengthCounterExtension } },
  dataCyExtensionConfig,
  asyncValidationExtensionConfig,
];
